import { getOrders, payOrder, payOrders } from "services/order";
import { TCheckoutContext } from "./types";
import { setCookie, setLocalStorage } from "utils";
import { IOrder } from "types/order";

export const services = {
  getOrders: (ctx: TCheckoutContext) => {
    setLocalStorage(ctx.params.CustomerID, "CustomerID");
    setLocalStorage(ctx.params.TaxNumber, "TaxNumber");
    setCookie(ctx.params.CustomerID, "CustomerID");
    setCookie(ctx.params.TaxNumber, "TaxNumber");
    return getOrders(ctx.params);
  },
  payOrder: (ctx: TCheckoutContext, e: { description: string }) => {
    const selecteds = ctx.orders.filter((order) => order.selected);
    return payOrder({
      invoice_number: selecteds[0]?.invoice_number,
      remaining_amount: selecteds[0]?.remaining_amount,
      description: e?.description || "",
    });
  },
  payOrders: (ctx: TCheckoutContext, e: { description: string }) => {
    const selecteds = ctx.orders.filter((order) => order.selected);
    const items = selecteds.map((selected: IOrder) => ({
      invoice_number: selected?.invoice_number,
      vat_invoice_number: selected?.vat_invoice_number,
      remaining_amount: selected?.remaining_amount,
    }));
    let identifier = "HD";
    for (let i = 0; i < selecteds.length; i++) {
      const curr_invoice_number = selecteds[i].invoice_number;
      if (identifier.length + curr_invoice_number.length + 1 > 39) break;
      identifier += " " + curr_invoice_number;
    }
    return payOrders({
      items: items,
      description: e?.description || "",
      identifier: identifier,
    });
  },
};
